import Fuse from 'fuse.js';

const getInstanceAttributeKeys = (data) => {
    if (!data.instanceAttributes || typeof data.instanceAttributes !== 'object') {
        return [];
    }

    return Object.keys(data.instanceAttributes)
                .filter(key => typeof data.instanceAttributes[key] === 'string')
                .map(key => `instanceAttributes.${key}`);
};

export const toggleSearchSuggestions = (display) => {
    let search_suggestions = document.getElementById("search_suggestions")
    if (display) {
        search_suggestions.style.display = "block"
    } else {
        search_suggestions.style.display = "none"
    }
}

export const getSearchSuggestions = (newValue, data) => {
    if (!data || !Array.isArray(data)) return [];

    // Fuse.js instance for searching in "id" and "label"
    const fuseInstance = new Fuse(data, {
        keys: ["data.id", "data.label", "data.name"],  // Searching on "id" and "label"
        threshold: 0.3,
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
    });

    // Perform the search
    const instanceResult = fuseInstance.search(newValue).map(res => ({
        isInstance: true,
        id: res.item.data.id,
        attribute: res.matches[0].key.split('.').pop(),
        result: res.matches[0].value,
        name: res.item.data["name"],
        score: res.score
    }));

    // Sort results by score (lower score means a better match)
    instanceResult.sort((a, b) => a.score - b.score);

    return instanceResult;
};

export const updateInputSuggestions = (e, data, setSearchResults, num_search_suggestions) => {
    const newValue = e.target.value;

    let search_suggestions = document.getElementById("search_suggestions")
    if (newValue.length > 2 && data) {
        // Fuse search for instance
        const result = getSearchSuggestions(newValue, data)

        if (result && result.length > 0) {
            search_suggestions.style.display = "block"
        } else {
            search_suggestions.style.display = "none"
        }

        setSearchResults(result.slice(0,num_search_suggestions));
    } else {
        search_suggestions.style.display = "none"
        setSearchResults([]);
    }
};